import * as tslib_1 from "tslib";
import { Base } from '../base-component';
import './search.component.scss';
import * as $ from 'jquery';
var Search = /** @class */ (function (_super) {
    tslib_1.__extends(Search, _super);
    function Search(element) {
        var _this = _super.call(this, element) || this;
        _this.lastSearch = '';
        _this.jsonFileUrl = '';
        _this.notFoundText = '';
        return _this;
    }
    Search.prototype.init = function () {
        var notFoundData = $(this.element).data('notfound');
        if (notFoundData && notFoundData !== "") {
            this.notFoundText = notFoundData;
        }
        else {
            this.notFoundText = "No results found for:";
        }
        var jsonFileData = $(this.element).data('jsonfile');
        if (jsonFileData && jsonFileData !== "") {
            this.jsonFileUrl = jsonFileData;
        }
        else {
            // this.jsonFileUrl = "/static_file/SBG/conf/search/search__terms.json";
            this.jsonFileUrl = "/file_source/mock/search__dummy.json";
        }
        var getLang = this.getCookie('sbgLang');
        if (getLang) {
            if (jsonFileData && jsonFileData !== "") {
                this.jsonFileUrl = jsonFileData;
            }
            else {
                this.jsonFileUrl = "/static_file/SBG/conf/search/search__terms-" + getLang + ".json";
            }
        }
    };
    Search.prototype.bindEvents = function () {
        var _this = this;
        var jsonUrl = this.jsonFileUrl;
        $('.search__wrapper .icon[data-icon="icon-close"]').click(function (e) {
            e.stopImmediatePropagation();
            $('.search__wrapper-input').val('');
            _this.closeResults();
        });
        $('.header__secondary-bar-search').click(function () {
            $('.search').addClass('search--opening');
            $('.search').addClass('search--open');
            _this.expandSearch();
        });
        $(".search__wrapper-input").keydown(function (e) {
            if (e.keyCode === 13) {
                $('.icon[data-icon="icon-search-blue"]').click();
            }
            else {
                $('.icon[data-icon="icon-search-blue"]').change();
            }
        });
        $('.icon[data-icon="icon-search-blue"]').change(this.debounce(function () {
            _this.lastSearch = $('.search__wrapper-input').val().toLowerCase();
            $('.search__results-content > a').remove();
            if (_this.lastSearch.length < 4) {
                if ($('.search__results').hasClass('search__results--open')) {
                    $('.search__results').addClass('search__results--closing');
                }
            }
            if (_this.lastSearch.length >= 4) {
                $('.search__results-busy').show();
                $('.search__results').addClass('search__results--open').removeClass('search__results--closing');
                _this.http.get(jsonUrl).then(function (response) {
                    var docfragment = document.createDocumentFragment();
                    var filter = response.data.filter(function (item) {
                        return item.searchCriteria.toLowerCase().indexOf(_this.lastSearch) > -1;
                    }).sort(function (a, b) {
                        return a.weight - b.weight;
                    });
                    if (filter.length === 0) {
                        $('.search__results-busy').hide();
                        if ($('.search__results').hasClass('search__results--open')) {
                            $('.search__results').addClass('search__results--closing');
                        }
                    }
                    else {
                        filter.forEach(function (element, index) {
                            if (index >= 5)
                                return;
                            var target = '';
                            if (_this.validURL(element.relatedPage)) {
                                target = 'target="_blank"';
                            }
                            docfragment.appendChild(document.createRange()
                                .createContextualFragment("\n\t\t\t\t\t\t\t\t\t<a href=\"" + element.relatedPage + "\" class=\"search__results-link\" " + target + ">\n\t\t\t\t\t\t\t\t\t\t" + element.searchCriteria + "\n\t\t\t\t\t\t\t\t\t</a>\n\t\t\t\t\t\t\t\t"));
                        });
                        $('.search__results-busy').hide();
                        $('.search__results-content')[0].appendChild(docfragment);
                    }
                });
            }
        }, 200, false));
        $('.icon[data-icon="icon-search-blue"]').click(function () {
            _this.closeResults();
            $('form.search__wrapper').submit();
        });
        window.addEventListener('resize', this.debounce(function () {
            if ($('.search').hasClass('search--open')) {
                _this.expandSearch();
            }
        }, 50, false));
    };
    Search.prototype.debounce = function (func, wait, immediate) {
        var timeout;
        return function () {
            var context = this, args = arguments;
            var later = function () {
                timeout = null;
                if (!immediate)
                    func.apply(context, args);
            };
            var callNow = immediate && !timeout;
            clearTimeout(timeout);
            timeout = setTimeout(later, wait);
            if (callNow)
                func.apply(context, args);
        };
    };
    ;
    Search.prototype.closeResults = function () {
        $('.search__results').addClass('search__results--closing');
        setTimeout(function () {
            $('.search').show();
            $('.search__wrapper').width(0);
            $('.search').addClass('search--closing');
            setTimeout(function () {
                $('.search').removeClass('search--open').removeClass('search--closing');
                $('.search__results').removeClass('search__results--open').removeClass('search__results--closing');
            }, 350);
        }, 200);
    };
    Search.prototype.OLDexpandSearch = function () {
        var windowWidth = $(window).width();
        if (windowWidth < 768) {
            $('.search__wrapper').css('right', "0px");
            $('.search__wrapper').width(windowWidth);
            $('.search__results').width(windowWidth - 60);
            setTimeout(function () {
                $('.search').removeClass('search--opening');
            }, 350);
        }
        else {
            var left = $('.header__secondary-bar-login').offset().left;
            var rightPos = windowWidth - left;
            var searchWidth = this.calculateAvailableWidth();
            $('.search__wrapper').css('right', rightPos + "px");
            $('.search__wrapper').width(searchWidth);
            $('.search__results').width(searchWidth - 60);
            setTimeout(function () {
                $('.search').removeClass('search--opening');
            }, 350);
        }
        $('input.search__wrapper-input').focus();
    };
    Search.prototype.OLDcalculateAvailableWidth = function () {
        var windowWidth = $(window).width();
        var right = windowWidth - $('.header__secondary-bar-login').offset().left;
        var left = $('.header__secondary-bar-left').offset().left + $('.header__secondary-bar-left').width();
        if (left < 250) {
            left = 250;
        }
        return windowWidth - (right + left);
    };
    Search.prototype.expandSearch = function () {
        var windowWidth = $(window).width();
        if (windowWidth < 768) {
            $('.search__wrapper').css('right', "0px");
            $('.search__wrapper').width(windowWidth);
            $('.search__results').width(windowWidth - 60);
            setTimeout(function () {
                $('.search').removeClass('search--opening');
            }, 350);
        }
        else {
            var left = 0;
            if (document.querySelector('.header__secondary-bar-login')) {
                left = $('.header__secondary-bar-login').offset().left;
            }
            else {
                left = $('.header__secondary-bar-search').offset().left + 84;
            }
            var rightPos = windowWidth - left;
            var searchWidth = this.calculateAvailableWidth();
            $('.search__wrapper').css('right', rightPos + "px");
            $('.search__wrapper').width(searchWidth);
            $('.search__results').width(searchWidth - 60);
            setTimeout(function () {
                $('.search').removeClass('search--opening');
            }, 350);
        }
        $('input.search__wrapper-input').focus();
    };
    Search.prototype.calculateAvailableWidth = function () {
        var windowWidth = $(window).width();
        var right = 0;
        if (document.querySelector('.header__secondary-bar-login')) {
            right = windowWidth - $('.header__secondary-bar-login').offset().left;
        }
        else {
            right = windowWidth - ($('.header__secondary-bar-search').offset().left + 84);
        }
        var left = $('.header__secondary-bar-left').offset().left + $('.header__secondary-bar-left').width();
        if (left < 250) {
            left = 250;
        }
        return windowWidth - (right + left);
    };
    Search.prototype.validURL = function (str) {
        var pattern = /(ftp|http|https):\/\/(\w+:{0,1}\w*@)?(\S+)(:[0-9]+)?(\/|\/([\w#!:.?+=&%@!\-\/]))?/;
        if (pattern.test(str)) {
            return true;
        }
        return false;
    };
    Search.prototype.getCookie = function (cname) {
        var name = cname + "=";
        var ca = document.cookie.split(';');
        for (var i = 0; i < ca.length; i++) {
            var c = ca[i];
            while (c.charAt(0) === ' ') {
                c = c.substring(1);
            }
            if (c.indexOf(name) === 0) {
                return c.substring(name.length, c.length);
            }
        }
        return "";
    };
    return Search;
}(Base));
export { Search };



//////////////////
// WEBPACK FOOTER
// ./components/search/search.component.ts
// module id = 486
// module chunks = 0